import { BbEnv, getBbEnv } from 'src/utils/bb-env';

export const annotationsBaseUrl = (prodSuffix: '2.0' | 'internal'): string => {
  const urlBase = '/!api';
  return getBbEnv() === BbEnv.Production
    ? `${urlBase}/${prodSuffix}`
    : `${urlBase}/internal/pipelines/stg/internal`;
};
